<template>
    <div>
        <van-tabs v-model="active" swipeable animated sticky color="#066BEE" line-height="2px"
                  @change="getListData()">
            <van-tab v-for="item in list" :key="item.type" :title="item.title">
                <van-list v-if="item.list.length > 0" v-model="item.loading" :finished="item.finished"
                          finished-text="没有更多了" @load="getListData">
                        <div v-for="(subItem,index) in item.list" :key="index" class="card" @click="detail(subItem.memberId)">
                            <div>
                                <div style="margin: 15px 0 10px 10px; color: #4E4E4E; font-size: 18px;">{{subItem.memberName}}<span v-if="item.title ==='全部'" style="color: #066BEE; font-size: 14px; margin-left: 5px;">{{subItem.userRelation}}</span></div>
                                <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">{{'身份证号码：' + subItem.memberIdCard}}</div>
                                <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">{{'手机号码：' + subItem.memberPhone}}</div>
                                <div class="label">推荐保障</div>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <span style="color: #066BEE; font-size: 14px;">查看</span>
                                <van-icon name="arrow" color="#066BEE" style="margin-right: 5px;"></van-icon>
                            </div>
                        </div>
                </van-list>
                <div v-else
                     style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <van-image :src="require('@/assets/无数据.png')" width="120px" height="94px" style="margin-top: 35%;"/>
                    <span style="margin-top: 20px; color: #999999; font-size: 14px;">您未添加任何一位家人</span>
                </div>
            </van-tab>
        </van-tabs>
        <van-button round type="info" color="linear-gradient(to right, #4587DD, #40B6F8)"
                    style="position: fixed; bottom: 20px; left: 10%; right: 10%; width: 80%;"
                    @click="add">立即添加
        </van-button>
    </div>
</template>

<script>


    import Vue from 'vue';
    import {Tab, Tabs, List, Cell, Icon, Image} from 'vant';

    Vue.use(Tab).use(Tabs).use(List).use(Cell).use(Icon).use(Image);

    export default {
        name: "FamilyList",
        data() {
            return {
                active: 0,
                pageSize: 10,
                list: [
                    {title: '全部', type: '', list: [], page: 0, loading: false, finished: false},
                    {title: '父亲', type: '父亲', list: [], page: 0, loading: false, finished: false},
                    {title: '母亲', type: '母亲', list: [], page: 0, loading: false, finished: false},
                    {title: '夫妻', type: '夫妻', list: [], page: 0, loading: false, finished: false},
                    {title: '儿女', type: '儿女', list: [], page: 0, loading: false, finished: false},
                    {title: '兄弟姐妹', type: '兄弟姐妹', list: [], page: 0, loading: false, finished: false},
                    {title: '自己', type: '自己', list: [], page: 0, loading: false, finished: false},
                    {title: '其他', type: '其他', list: [], page: 0, loading: false, finished: false},
                ],
            }
        },
        created() {
            this.getListData()
        },
        methods: {
            getListData() {
                const item = this.list[this.active]
                if(item.finished){
                    return;
                }
                item.page++
                item.loading = true
                this.$axios.get("/member/list", {
                    params: {userRelation: item.type},
                    page: item.page,
                    pageSize: this.pageSize
                }).then(res => {
                    item.loading = false
                    const datas = res.data.rows;
                    item.list = item.list.concat(datas);
                    if (datas.length < this.pageSize) {
                        item.finished = true;
                    }
                }).catch(err => {
                    item.loading = false
                })
            },
            add() {
                this.$router.push('/addFamily')
            },
            detail(id) {
                this.$router.push({path:'/familyDetail', query: {id: id}})
            }
        }
    }
</script>

<style scoped>
    .card {
        display: flex; justify-content: space-between; align-items: center; padding: 10px 0; margin: 10px; background-color: white;
        box-shadow:0px 2px 4px 0px rgba(231,231,231,0.5);
        border-radius:4px;
    }

    .label {
        width:78px;
        height:24px;
        line-height: 24px;
        background:linear-gradient(270deg,rgba(64,182,248,1) 0%,rgba(69,135,221,1) 100%);
        border-radius:0px 12px 12px 0px;
        color: white;
        font-size: 14px;
        text-align: center;
        position: relative;
        right: 2px;
    }

    .label:before {
        content: '';
        background:linear-gradient(270deg,rgba(64,182,248,1) 0%,rgba(69,135,221,1) 100%);
        width: 2px;
        height: 2px;
        position: relative;
        bottom: 2px;
        display: block;
    }
</style>
